"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlRefiGuaranteeIneligibilityReason = void 0;
/** Why a loan application does not belong to the PL refi guarantee cohort. */
var PlRefiGuaranteeIneligibilityReason;
(function (PlRefiGuaranteeIneligibilityReason) {
    PlRefiGuaranteeIneligibilityReason["noInviteMail"] = "noInviteMail";
    PlRefiGuaranteeIneligibilityReason["campaignNotEnrolled"] = "campaignNotEnrolled";
    PlRefiGuaranteeIneligibilityReason["secondLienDetected"] = "secondLienDetected";
})(PlRefiGuaranteeIneligibilityReason || (exports.PlRefiGuaranteeIneligibilityReason = PlRefiGuaranteeIneligibilityReason = {}));
